/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import { BodyText, Card, Icon, Title } from './core';
import MediaQueries from '../constants/MediaQueries';
import withBreakpoint from './withBreakpoint';

function ServiceCard({
  icon,
  title,
  description,
  path,
  breakpoint,
}: {
  icon: any,
  title: string,
  description: string,
  button: string,
  path: string,
  breakpoint: string,
}) {
  return (
    <Card className={Styles.Card} to={path} elevated={true} bordered={true}>
      <div className={Styles.Icon}>{icon}</div>
      <div>
        <Title align="center" weight="bold" className={Styles.Title}>
          {title}
        </Title>
        {breakpoint !== 'small' && <BodyText size="14">{description}</BodyText>}
        {path && <Icon name="arrow-big-indigo-right" className={Styles.Arrow} />}
      </div>
    </Card>
  );
}

const IconOffset = -50;

const Styles = {
  Card: css`
    width: 100%;
    padding: 0 32px 22px;
    margin-bottom: ${-IconOffset}px;
    ${MediaQueries.Medium} {
      padding: 0 32px 32px;
    }
  `,
  Icon: css`
    margin-top: ${IconOffset}px;
  `,
  Arrow: css`
    margin-top: 16px;
    ${MediaQueries.Medium} {
      margin-top: 24px;
    }
  `,
  Title: css`
    margin: 22px 0 0px 0;
    ${MediaQueries.Medium} {
      margin: 32px 0 12px 0;
    }
  `,
};

export default withBreakpoint(ServiceCard);



// WEBPACK FOOTER //
// ./src/ui/components/ServiceCard.js